<!--
 * @Description: 二级科室详情组件
 * @Author: gaohc
 * @Date: 2022-04-02 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="dep-details-dialog" width="600px" :title="dialogTitle"
      :visible.sync="visible" :close-on-click-modal="false" @open="initData"
      :before-close="handleCancel" center>
      <div class="dialog-body">
        <div>
          <span class="search-title">所属医院：</span>
          <span>{{ secondDepData.hospitalName }}</span>
        </div>
        <div class="margin-div">
          <span class="search-title">服务机构：</span>
          <span>
            {{ secondDepData.institutionName ? secondDepData.institutionName : "- -" }}
          </span>
        </div>
        <div class="margin-div">
          <span class="search-title">一级科室：</span>
          <span>{{ secondDepData.department1Name }}</span>
          <el-checkbox :disabled="!secondDepData.canSelectNoDepartment" style="margin-left: 30px"
            @change="handleIshaveSecondDepChange" v-model="secondDepData.noDepartment">
						无二级科室
					</el-checkbox>
        </div>
        <div style="margin: 20px 0 40px 0; min-height: 32px">
          <div v-if="!secondDepData.noDepartment">
            <span class="search-title">二级科室：</span>
            <el-input size="small" style="width: 240px" v-model.trim="secondDepData.department2Name"
              placeholder="请输入二级科室名称">
            </el-input>
          </div>
        </div>
        <div v-if="secondDepData.inpatientWardList && secondDepData.inpatientWardList.length">
          <div class="ward-list-header">
            <span>病房设置</span>
            <span @click="handleAddWard" class="add-dep-text">
							<i class="el-icon-circle-plus-outline"></i>
							新增病房
						</span>
          </div>
          <div class="ward-list-item" v-for="(item, idx) in secondDepData.inpatientWardList" :key="idx">
            <div class="ward-name">
              <span>{{ item.name }}</span>
            </div>
            <div class="ward-number-main">
              <span class="ward-number" v-for="(ward, index) in item.bedAmount" :key="index">
                {{ getBedNumber(item.bedStartNo, index) }}号
              </span>
              <span v-if="item.bedAddNo">
                <span class="ward-number" v-for="(i, index) in (item.bedAddNo.split(','))" :key="i + index">
                  {{ parseInt(i) < 10 ? '0' + parseInt(i) : i }}床 (加)
                </span>
              </span>
            </div>
            <div class="operation-main">
              <i @click="handleEditWard(item)" class="el-icon-edit-outline"></i>
              <i @click="handelDeleteWard(item)" class="el-icon-delete"></i>
            </div>
          </div>
        </div>
        <div class="nodata-main" v-else>
          <el-image :src="src"></el-image>
          <span>
						该科室还没有设置病房，
            <span @click="handleAddWard" style="color: #3a7ff3; cursor: pointer">
              点击去新增病房
            </span>
          </span>
        </div>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSaveSecondDep">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Util from "@/global/Util.js";
  import Constant from "@/global/Constant.js";
  import depStore from "./DepStore.js";

  export default {
    name: "SecondDepartmentDialog",

    depStore,

    props: ["visible", "mode", "topDepId", "level2DepId", "topDepName", "hospitalId"],

    data() {
      return {
        src: require("../../../../assets/hspmng/icon-hspmng-nodata.png"),
        secondDepData: {
          department1Name: "",
          department2Name: "",
          inpatientWardList: [],
        },
        name: "",
        checked: false,
      };
    },

    computed: {
      dialogTitle() {
        switch (this.mode) {
          case "add":
            return "新增二级科室";
          case "edit":
            return "编辑二级科室";
          case "details":
            return "二级科室详情";
          default:
            return "----";
        }
      },

      getBedNumber() {
        return function (bedStartNo, index) {
          let numb = bedStartNo + index;
          return numb > 9 ? numb.toString() : "0" + numb;
        };
      }
    },
    
    methods: {
      //保存病房信息
      handleSaveSecondDep() {
        if (!this.secondDepData.noDepartment && !this.secondDepData.department2Name) {
          this.$message({
            message: "请输入二级科室名称",
            type: "warning",
          });
          return;
        }

        let url = this.mode == "add" ? Constant.URL_SAVE_LEVEL_2DEPARTMENT
            : Constant.URL_UPDATE_LEVEL_2DEPARTMENT;
        let method = this.mode == "add" ? "POST" : "PUT";
        let param = {
          department: {
            category: 1,
            hospitalId: this.secondDepData.hospitalId,
            level: 2,
            name: this.secondDepData.department2Name,
            department1Id: this.secondDepData.topDepId,
          },
          inpatientWardList: this.secondDepData.inpatientWardList,
          isSelectNoLevel2Department: this.secondDepData.noDepartment,
        };
        if (this.mode == "edit") {
          param.department.id = this.level2DepId;
        }
        let [header, esParam] = this.encryptionUtil.encryptAndSignBody(param,
			  	Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
			  	Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };

        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$emit("close-dialog", true);
        });
      },

      handleIshaveSecondDepChange() {
        this.secondDepData.department2Name = "";
      },

      // 新增病房
      handleAddWard() {
        this.$emit("add-ward", "secondDepAdd");
      },

      // 编辑病房
      handleEditWard(item) {
        if (item.id) {
          this.$emit("edit-ward", item.id, "secondDepAdd");
        } else {
          depStore.commit("changeInpatientWard", item);
          this.$emit("edit-add-ward", item, "secondDepAdd");
        }
      },

      // 删除病房
      handelDeleteWard(item) {
        let arr;
        if (item.isHavaNoFinishOrder) {
          this.$message({
            message: "该病房有关联未完成订单,暂不支持删除",
            type: "warning",
          });
          return;
        }

        if (item.id) {
          arr = Util.delMemoHandler(
            this.secondDepData.inpatientWardList,
            "id",
            item.id
          );
        } else {
          arr = Util.delMemoHandler(
            this.secondDepData.inpatientWardList,
            "name",
            item.name
          );
        }

        this.$set(this.secondDepData, "inpatientWardList", arr);
      },

      //病房新增或者修改后对数据的处理
      handleInpatitentData(param) {
        let wardData = depStore.state.inpatientWard;
        let inpatientWardList = this.secondDepData.inpatientWardList;
        //深拷贝解决修改对象后，数组内对象都会被改变的问题
        let data = Object.assign({}, JSON.parse(JSON.stringify(wardData)));
        if (param == "editNotHaveId") {
          inpatientWardList = Util.formateArrObjData(inpatientWardList, data, "name");
          this.$set(this.secondDepData, "inpatientWardList", inpatientWardList);
          return;
        }

        if (wardData.id) {
          inpatientWardList = Util.formateArrObjData(inpatientWardList, data, "id");
        } else {
          wardData.hospitalId = this.secondDepData.hospitalId;
          wardData.departmentId = this.mode == "add" ? 0 : this.level2DepId;
          inpatientWardList = inpatientWardList ? inpatientWardList : [];
          inpatientWardList.push(data);
        }

        this.$set(this.secondDepData, "inpatientWardList", inpatientWardList);
      },

      handleCancel() {
        this.clearData();
        this.$emit("close-dialog", false);
      },

      initData() {
        this.clearData();
        this.querySecondDepData();
      },

      //初始化data
      querySecondDepData() {
        this.secondDepData.topDepId = this.topDepId;
        let url = this.mode == "add" ? Constant.URL_GET_LEVEL_2DEPARTMENT_DO4ADD_V22
          : Constant.URL_GET_LEVEL_2DEPARTMENT_DO4UPDATE;
        let params =this.mode == "add" ? {department1Id: this.topDepId} : {id: this.level2DepId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: url,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          this.secondDepData = result.data;
        });
      },

      clearData() {
        this.secondDepData = {};
      }
    },
  };
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.dialog-body {
  padding: 0 30px 50px 25px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.nodata-main {
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.nodata-main .el-image {
  width: 186px;
  height: 100px;
  margin-bottom: 30px;
}

.ward-list-header {
  display: flex;
  justify-content: space-between;
  color: #000000;
  font-size: 14px;
  margin: 25px 0;
  font-weight: bold;
}

.ward-list-header .add-dep-text {
  color: #3a7ff3;
  font-weight: 400;
  cursor: pointer;
}

.ward-list-header .add-dep-text .el-icon-circle-plus-outline {
  margin-right: 4px;
  font-weight: bold;
}

.ward-list-item {
  display: flex;
  align-items: center;
  border-radius: 6px 0px 0px 6px;
  margin-bottom: 15px;
}

.ward-list-item .ward-name {
  width: 96px;
  height: 84px;
  background: #c2d8fb;
  border: 1px solid #c2d8fb;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #333333;
  font-size: 17px;
  font-weight: bold;
  overflow-y: auto;
}

.ward-list-item .ward-number-main {
  flex: 1;
  height: 84px;
  border: 1px solid #c2d8fb;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.ward-list-item .ward-number-main .ward-number {
  width: 66px;
  height: 28px;
  background: #feffff;
  border-radius: 3px;
  border: 1px solid #c2d8fb;
  margin: 10px 0 0 13px;
  text-align: center;
  line-height: 28px;
  color: #333333;
  font-size: 14px;
  display: inline-block;
}

.ward-list-item .operation-main {
  width: 101px;
  height: 84px;
  background: #feffff;
  border: 1px solid #c2d8fb;
  line-height: 84px;
  text-align: center;
  font-size: 16px;
  color: #3a7ff3;
  cursor: pointer;
}

.ward-list-item .operation-main .el-icon-delete {
  color: #f33a3a;
  margin-left: 10px;
}

.ward-list-item .ward-number-main .add-bed-wrap {
  width: auto;
  padding: 0 5px;
  height: auto;
  text-align: left;
  margin-bottom: 10px;
}

.dialog-footer {
  text-align: center;
}

.margin-div {
  margin-top: 18px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/components/departmentList/SecondDepartmentDialog.vue